import {Model} from '@vuex-orm/core'

export class Field extends Model {
  static entity = 'Field'

  static fields () {
    return {
      id: this.number(null),
      value: this.attr(null),
      label: this.string(''),
      enabled: this.boolean(false),
      fieldOngletId: this.attr(null)
    }
  }

  static fetchFields ($depotVente) {
    return this.api().get('/deposant/' + $depotVente + '/colonnes');
  }

  get text () {
    return this.label
  }
}
